"use strict";
var r, u;
function e() {
  return u || (u = 1, r = Math.round), r;
}
export {
  e as __require
};
//# sourceMappingURL=index.es315.js.map
